// extracted by mini-css-extract-plugin
export default {"searchBox":"searchText_searchBox__Vqhar"};